import React from 'react'

interface PredictionBadgeProps {
  probability: number  // 0 to 1
  size?: 'sm' | 'md'
}

export function PredictionBadge({ probability, size = 'md' }: PredictionBadgeProps) {
  const pct = Math.round(probability * 100)

  let colorClass: string
  if (probability > 0.6) {
    colorClass = 'bg-red-100 text-red-700 border border-red-200'
  } else if (probability > 0.3) {
    colorClass = 'bg-amber-100 text-amber-700 border border-amber-200'
  } else {
    colorClass = 'bg-gray-100 text-gray-600 border border-gray-200'
  }

  const sizeClass = size === 'sm'
    ? 'text-xs px-1.5 py-0.5 rounded'
    : 'text-sm px-2 py-1 rounded-md font-medium'

  return (
    <span className={`inline-flex items-center ${colorClass} ${sizeClass}`}>
      {pct}% top-5 risk
    </span>
  )
}

export default PredictionBadge
